import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { CreditCard } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DirectDebitCard = () => {
  const { token } = useAuth();
  const [mandate, setMandate] = useState(null);
  const [busy, setBusy] = useState(false);
  const headers = { Authorization: `Bearer ${token}` };

  const fetchMandate = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/online-payments/my-mandate`, { headers });
      setMandate(res.data);
    } catch (e) { /* silent */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => { fetchMandate(); }, [fetchMandate]);

  const setupDirectDebit = async () => {
    setBusy(true);
    try {
      const res = await axios.post(`${API_URL}/online-payments/my-mandate/setup`,
        { origin_url: window.location.origin }, { headers });
      window.location.href = res.data.url;
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Грешка при създаване на директен дебит');
      setBusy(false);
    }
  };

  const active = mandate?.has_mandate && mandate?.mandate_status === 'active';

  return (
    <Card className="p-4 border-indigo-200 bg-indigo-50/40" data-testid="direct-debit-card">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-indigo-100 flex items-center justify-center shrink-0">
          <CreditCard className="h-5 w-5 text-indigo-600" />
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-slate-800">Такса за онлайн обучение — директен дебит</h4>
          <p className="text-sm text-slate-500">
            {active
              ? 'Директният дебит е активен. Таксата се събира автоматично.'
              : 'Настройте директен дебит, за да се събира таксата автоматично от банковата ви сметка.'}
          </p>
        </div>
        <div className="shrink-0">
          {active ? (
            <Badge className="bg-green-100 text-green-700">Активен</Badge>
          ) : (
            <Button onClick={setupDirectDebit} disabled={busy} data-testid="setup-direct-debit-btn"
              className="bg-indigo-600 hover:bg-indigo-700 text-white">
              {busy ? 'Момент...' : 'Настрой директен дебит'}
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
};
